import React from 'react'
import { Link } from 'react-router-dom'

interface IProps {
    path: string
    title: string
}

export default function LinkButton(props: IProps): React.ReactElement {
    return (
        <Link to={props.path} className='link-button' title={props.title}>
            {props.title}
        </Link>
    )
}
